export default __webpack_public_path__ + "img/aro-perks.png";